import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { IngredientsServices } from "../../../../../ingredients/services";
import { Globals } from "../../../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateIngredientPage } from '../../../../../components/popups/create-ingredient/create-ingredient';
/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-partial-ingredients-select',
    templateUrl: 'dish-partial-ingredients-select.html',
})
export class DishPartialIngredientsSelectPage {

    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };
    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public ingredientsServices: IngredientsServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public translate: TranslateService,
        public modalCtrl: ModalController) {
    }

    insert(ingredient) {
        //Funcion que añadir al array de ingredientes seleccionados para el Food cost
        if (!this.check(ingredient.UID)) { //Buscamos si el ingrediente ya esta anadido
            var _array = Array();
            _array.push(ingredient.UID); //UID
            _array.push(ingredient.name); //Name
            if (ingredient.allergens == undefined) {
                ingredient.allergens = [];
                _array.push(ingredient.allergens);
            } else {
                _array.push(ingredient.allergens);
            }
            if (ingredient.sub_recipe) {
                _array.push(this.ingredientsServices.returnPricePerMeasurement(ingredient.price_static, ingredient.real_weight));
            } else {
                _array.push(ingredient.price_static);
            }
            _array.push(ingredient.measurement); //Measurement
            _array.push(0); //Quantity
            _array.push(0); //Waste
            if (ingredient.sub_recipe) {
                _array.push(this.translate.instant('general-sin-proveedor')); //Provider static
            } else {
                _array.push(ingredient.provider_static); //Provider static
            }
            _array.push(0); //Cantidad bruta
            _array.push(0); //Precio
            _array.push(ingredient.type);

            this.ingredientsServices.foodcost_array_tmp.push(_array);
            this.ingredientsServices.foodcost_array_tmp = [...this.ingredientsServices.foodcost_array_tmp];

            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-ingrediente') + ' ' + ingredient.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-ingrediente-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.ingredientsServices.foodcost_array_tmp.length; i++) {
            var obj = this.ingredientsServices.foodcost_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }

    nextPage() {
        if (this.ingredientsServices.page_active < this.ingredientsServices.pagesIngredients.length) {
            this.ingredientsServices.page_active += 1
        }
        this.ingredientsServices.getListIngredientsMinMax();
        document.getElementById('scroll_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    previusPage() {
        if (this.ingredientsServices.page_active > 1) {
            this.ingredientsServices.page_active -= 1;
        }
        this.ingredientsServices.getListIngredientsMinMax();
        document.getElementById('scroll_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    activePage(number) {
        this.ingredientsServices.page_active = number;
        this.ingredientsServices.getListIngredientsMinMax();
        document.getElementById('scroll_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }
    openCreateIngredient() {
        let profileModal = this.modalCtrl.create(CompCreateIngredientPage, {
            origin: 'dish'
        });
        profileModal.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-cost/dish-ingredients-select/dish-partial-ingredients-select/dish-partial-ingredients-select.ts